__turbopack_context__.v({
  "circularContainer": "ooiBDq_circularContainer",
  "content": "ooiBDq_content",
  "imgContainer": "ooiBDq_imgContainer",
  "lowerBlock": "ooiBDq_lowerBlock",
  "root": "ooiBDq_root",
  "sticky": "ooiBDq_sticky",
  "text": "ooiBDq_text",
  "upperBlock": "ooiBDq_upperBlock",
});
